/**
 * Today's date in Brussels as `YYYY-MM-DD`.
 *
 * A pilot's weeks are Brussels weeks, so "has it started" and "has access
 * ended" have to be answered there rather than in UTC or in the reader's own
 * zone — a server at UTC midnight is already Monday in Brussels.
 */
export function todayInBrussels(now: Date = new Date()): string {
  return new Intl.DateTimeFormat('en-CA', {
    timeZone: 'Europe/Brussels',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).format(now);
}
